import { Button, Form, Input, InputNumber, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useStateContext } from '~/contexts/ContextProvider';
import { instanceAuth } from '~/utils/axios';

import { useTranslation } from 'react-i18next';
import { NS } from '~/utils/ns';
const ModalWithdraw = ({ isOpen, setIsOpen }) => {
  const { formatMoney } = useStateContext();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation([NS['profile']]);
  const [setting, setSetting] = useState({});
  const { setAgency } = useStateContext();
  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleSubmit = async (data) => {
    try {
      setIsLoading(true);
      const res = await instanceAuth().post('/withdraw', data);
      if (!res.status) {
        return toast.error(t(`common:${res?.errCode}`));
      }
      toast.success(t('ruttienthanhcong'));
      handleCancel();
      const reload = await instanceAuth().get('/check');
      if (reload?.result?.status) {
        setAgency(reload?.result?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getSetting = async () => {
    try {
      const res = await instanceAuth().get('/setting');
      setSetting(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  return (
    <Modal open={isOpen} onCancel={handleCancel} footer={null}>
      <h3 className="font-semibold text-xl text-center">{t('ruttien')}</h3>
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label={t('sotienmuonrut')}
          name="money"
          required
          rules={[{ required: true, message: t('vuilongnhapsotienmuonrut') }]}>
          <InputNumber
            placeholder={t('sotienmuonrut')}
            className="w-full"
            formatter={(value) => {
              if (!value) return '';
              // Chia cho 1000 và format dấu phẩy
              const divided = Number(value) / 1000;
              return divided.toLocaleString('en-US', {
                maximumFractionDigits: 1,
              });
            }}
            parser={(value) => {
              if (!value) return '';
              // Bỏ dấu phẩy, chuyển về số gốc (nhân lại 1000)
              const raw = value.replace(/,/g, '');
              return (parseFloat(raw) || 0) * 1000;
            }}
          />
        </Form.Item>
        <p className="mt-[-20px] mb-3 text-orange-500">
          {t('phamviruttien')} : ({formatMoney(setting.min_withdraw)} ~{' '}
          {formatMoney(setting.max_withdraw)} )
        </p>
        <Form.Item
          label={t('matkhauruttien')}
          name="password"
          rules={[{ required: true, message: t('vuilongnhapmkruttien') }]}>
          <Input.Password placeholder={t('matkhauruttien')} />
        </Form.Item>
        <div className="flex justify-end gap-3">
          <Button onClick={handleCancel}>{t('common:cancel')}</Button>
          <Button className="bg-blue-500 text-white" htmlType="submit" loading={isLoading}>
            {t('ruttien')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalWithdraw;
